import { useMemo } from 'react'
import * as Sentry from '@sentry/react'
import { ToastTypes, launchToast } from '../../../components'
import { SENTRYTAGS } from '../../../logging'
import { useApi, useApiMutation } from '../../../utils'
import {
    GetPotentialMlpsQuerySchema,
    GetPotentialMlpsVariablesSchema,
    PushCheckedMlpsMutationSchema,
    PushCheckedMlpsVariablesSchema,
    type GetPotentialMlpsVariables,
    type PushCheckedMlpsVariables
} from '../mlp_schemas'

export const useGetPotentialMlpsQuery = (initialVariables: GetPotentialMlpsVariables) => {
    const variables = useMemo(
        () => GetPotentialMlpsVariablesSchema.parse(initialVariables),
        [initialVariables.lower_timestamp_threshold]
    )

    const result = useApi('/platform-mlp/get_potential_mlps', variables, GetPotentialMlpsQuerySchema, {
        queryKey: ['platform-mlp/get_potential_mlps', variables]
    })

    return {
        data: result.data,
        loading: result.isFetching,
        error: result.error,
        refetch: result.refetch
    }
}

export const usePushCheckedMlpsMutation = () => {
    const { mutateAsync, isPending, error } = useApiMutation<
        PushCheckedMlpsVariables,
        typeof PushCheckedMlpsMutationSchema
    >('/platform-mlp/push_checked_mlps', PushCheckedMlpsMutationSchema)

    const pushCheckedMlps = async (input: PushCheckedMlpsVariables) => {
        const variables = PushCheckedMlpsVariablesSchema.parse(input)
        try {
            const data = await mutateAsync(variables)
            return { data, errors: undefined }
        } catch (e) {
            launchToast(ToastTypes.Error, 'Error: Batch could not be submitted. Check the console for more details !')
            Sentry.setTag('component', SENTRYTAGS.MLP)
            Sentry.captureException(e)
            throw e
        }
    }

    return { pushCheckedMlps, loading: isPending, error }
}
